import React, { useEffect, useState } from 'react';
import { useAuth } from '../contexts/AuthContext';
import { notification } from 'antd';
import { useNavigate } from 'react-router-dom';
import { setPageMeta } from '../lib/seo';

const Login: React.FC = () => {
  const { login, user } = useAuth();
  const [isLoading, setIsLoading] = useState(false);
  const [formData, setFormData] = useState({
    email: '',
    password: '',
  });
  const navigate = useNavigate();

  useEffect(() => {
    if (user) {
      navigate('/dashboard', { replace: true });
    }
  }, [user, navigate]);

  useEffect(() => {
    setPageMeta({
      title: 'Login — Elorimi',
      description: 'Log in to your Elorimi account to manage your Cloud PC and Cloud VPS.',
    });
  }, []);

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    
    setIsLoading(true);
    try {
      await login(formData.email, formData.password);
    } catch (error: any) {
      const errorMessage = error.response?.data?.error || error.message || 'An error occurred';
      notification.error({ message: 'Login Failed', description: errorMessage });
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div className="auth-page">
      <div className="auth-container">
        <div className="auth-card glass">
          <h2 className="auth-title">Welcome Back</h2>
          <p className="auth-subtitle">Sign in to access your dashboard</p>
          
          <form onSubmit={handleSubmit} className="auth-form">
            <input
              type="email"
              name="email"
              placeholder="Email"
              value={formData.email}
              onChange={handleChange}
              required
            />
            
            <input
              type="password"
              name="password"
              placeholder="Password"
              value={formData.password}
              onChange={handleChange}
              required
            />
            
            <button type="submit" className="auth-btn primary" disabled={isLoading}>
              {isLoading ? 'Please wait...' : 'Sign In'}
            </button>
            
            <p className="auth-switch">
              Don't have an account? <a href="/register">Create one</a>
            </p>
          </form>
        </div>
      </div>
    </div>
  );
};

export default Login;
